/* ============================================================
   VEGECORE - email popup behaviour.
   Markup lives in snippets/vc-exit-popup.liquid (needs Liquid for
   the customer form tag), so this file only handles showing,
   hiding and the copy button.
   2026-10-23: the code and the "already seen" key are read from the
   popup's data-code / data-storage-key attributes, so the Deepavali
   popup copies DEEPAVALI and is shown once even to people who already
   dismissed the TRYVEGECORE popup. Defaults keep the old behaviour.
   Trigger: ~2.5s universal timer on mobile + desktop, with
   exit-intent as an earlier bonus trigger on desktop.
   Skipped on cart/checkout templates.
   ============================================================ */
(function () {
  var SHOW_DELAY_MS = 2500;
  var MIN_TIME_MS = 800;

  function init() {
    var overlay = document.getElementById('vcExitPop');
    if (!overlay) return;
    var CODE = overlay.getAttribute('data-code') || 'TRYVEGECORE';
    var STORAGE_KEY = overlay.getAttribute('data-storage-key') || 'vcExitPopupSeen';

    var justPosted =
      !!overlay.querySelector('[data-vc-posted]') ||
      window.location.search.indexOf('customer_posted=true') !== -1;

    var shown = false;
    var startTime = Date.now();
    var isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    function close() {
      overlay.classList.remove('is-open');
      document.removeEventListener('keydown', onKey);
      setTimeout(function () { overlay.setAttribute('hidden', ''); }, 250);
    }
    function onKey(e) { if (e.key === 'Escape') close(); }

    function open() {
      if (shown) return;
      shown = true;
      try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
      overlay.removeAttribute('hidden');
      void overlay.offsetWidth;
      overlay.classList.add('is-open');
      document.addEventListener('keydown', onKey);
      var email = overlay.querySelector('input[type="email"]');
      if (email) { try { email.focus({ preventScroll: true }); } catch (e) {} }
    }

    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    var closeBtn = overlay.querySelector('.vc-exitpop-close');
    if (closeBtn) closeBtn.addEventListener('click', close);

    overlay.querySelectorAll('[data-copy]').forEach(function (copyBtn) {
      copyBtn.addEventListener('click', function () {
        function fallbackCopy() {
          var ta = document.createElement('textarea');
          ta.value = CODE;
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.focus();
          ta.select();
          try { document.execCommand('copy'); } catch (e) {}
          document.body.removeChild(ta);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(CODE).catch(fallbackCopy);
        } else {
          fallbackCopy();
        }
        var original = copyBtn.textContent;
        copyBtn.textContent = 'Copied!';
        setTimeout(function () { copyBtn.textContent = original; }, 1800);
      });
    });

    if (justPosted) { open(); return; }

    try {
      if (localStorage.getItem(STORAGE_KEY)) return;
    } catch (e) {}

    var skipClasses = ['template-cart', 'template-checkout'];
    var bodyClass = document.body.className || '';
    for (var i = 0; i < skipClasses.length; i++) {
      if (bodyClass.indexOf(skipClasses[i]) !== -1) return;
    }

    setTimeout(open, SHOW_DELAY_MS);

    if (!isTouch) {
      document.addEventListener('mouseleave', function (e) {
        if (e.clientY <= 0 && Date.now() - startTime > MIN_TIME_MS) open();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();